<template>
  <nav class="mb-6 text-sm" aria-label="Breadcrumb">
    <ol class="flex items-center space-x-2">
      <template v-for="(item, index) in items" :key="index">
        <li>
          <template v-if="item.active">
            <span class="text-font-primary">{{ item.text }}</span>
          </template>
          <template v-else>
            <nuxt-link :to="item.to" class="text-primary hover:text-primary/80">
              {{ item.text }}
            </nuxt-link>
          </template>
        </li>
        <li v-if="index < items.length - 1" class="text-font-primary">/</li>
      </template>
    </ol>
  </nav>
</template>

<script setup lang="ts">
interface BreadcrumbItem {
  text: string;
  to?: string;
  active?: boolean;
}

const props = defineProps<{
  items: BreadcrumbItem[];
}>();
</script>
<style scoped lang="scss">
ol > li {
  font-size: 16px;
  margin-left: 4px !important;
}
</style>
